import DashboardPageView from "@features/dasboard/view";

const Dashboard = () => {
  return <DashboardPageView />;
};

export default Dashboard;
